import { useContext } from "react";
import { AuthContext, type AuthContextValue, type SessionUser } from "./auth-context";

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used within <AuthProvider>");
  }
  return ctx;
}

export function useCurrentUser(): SessionUser | null {
  return useAuth().user;
}
